<template>
  <div>
    <div class="container text m-y-3">
      <h3 class="m-y-2 titular-bajo">Cápsulas</h3>
      <p>
        Las cápsulas son una muestra sonora, visual y narrativa de las
        experiencias vividas por las y los estudiantes del PIES-AGILES. Dichos
        videos representan cuatro de los perfiles participantes dentro del
        programa, únicos y complementarios:
      </p>
      <ol>
        <li>Jóvenes con licenciatura</li>
        <li>Docentes de medio tiempo</li>
        <li>Personas promotoras y formadoras comunitarias</li>
        <li>Personas agentes locales</li>
      </ol>
      <p>
        Todos los perfiles son sujetos claves para la transformación de los
        territorios, cada uno incidiendo desde lo colectivo para el
        fortalecimiento de sus soberanías y agroecologías a través de las
        metodologías participativas que impulsan la ciencia de incidencia.
      </p>
    </div>

    <div class="container container-podcast">

      <div class="tablero-multimedia m-b-2 multimedia-container-accesibilidad">
        <TarjetasCapsulas
          v-for="item in listado_capsulas"
          :key="item.id"
          :titulo="item.titulo"
          :detalles="item.detalles"
          :texto="item.texto"
          :multimedia="item.multimedia"
          :identificador="item.id"

        />
      </div>

    </div>
  </div>
</template>

<script>
// import MapaInscritos from "@/components/DeprecadoMapaInscritos.vue"
import listado_capsulas from "@/assets/data/listado_capsulas.json";
import TarjetasCapsulas from "@/components/TarjetasCapsulas.vue";

export default {
  name: "Capsulas",
  components: {
    // MapaInscritos
    TarjetasCapsulas,
  },
  data() {
    return {
      domain: process.env.VUE_APP_ENI_DOMAIN,
      base_route: process.env.VUE_APP_BASE_ROUTE,
      listado_capsulas,
    };
  },
  computed: {
    obtenerNombreEni() {
      return this.$store.getters.obtenerNombreEni;
    },
    vistaSimplificada() {
      return this.$store.getters.tieneVistaSimplificada;
    },

  },
};
</script>

<style lang="scss" scoped>

.cover-gradient {
  padding: $gap * 4 $gap $gap;
  .cover-logos {
    margin-top: 200px;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      width: 400px;
    }
  }
  .cover-text {
    padding-top: 80px;
    margin: 0px auto;
  }

  @media (min-width: map-get($media-queries-limit, "mobile")) {
    padding-top: $gap * 3;
  }
}

h4.titulo-left-movil,
h3.titulo-left-movil {
  @media (max-width: map-get($media-queries-limit, "mobile")) {
    text-align: left;
  }
}

.btn-external {
  font-size: map-get($fuente, "size-alto");
  border-radius: $gap;
  padding: 0 0 0 $gap;
  text-align: center;

  .icono {
    margin-left: $gap;
    transition: margin-left 0.3s ease-in-out;
  }

  .icono::before {
    background: map-get($color-boton, "texto");
    border: 1px solid map-get($color-boton, "fondo");
    color: map-get($color-boton, "fondo");
    font-size: 40px;
    line-height: $gap * 1.5;
    width: $gap * 1.5;
    height: $gap * 1.5;
    border-radius: $gap * 1.5;
    transition: all 0.3s ease-in-out;
  }

  &:hover,
  &:focus {
    .icono {
      margin-left: $gap * 1.5;
    }

    .icono::before {
      background: map-get($color-boton, "hover-texto");
      border: 1px solid map-get($color-boton, "hover-fondo");
      color: map-get($color-boton, "hover-fondo");
    }
  }
}

.video-responsivo {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.contacto {
  display: flex;
  justify-content: center;
  align-items: center;
}

.boton-ciatej {
  top: 4106px;
  left: 616px;
  width: 135px;
  height: 51px;
  color: #d13560;
  background: #ffffff;
  border: 2px solid #d13560;
  border-radius: 5px;
  opacity: 1;
  align-self: center;
}

.boton-ciatej:hover {
  background-color: white;
  box-shadow: 2px 2px 10px #00000029;
}

.boton-ciatej:focus {
  background-color: #d1889d;
  color: #ffffff;
}

.boton-repo {
  top: 2275px;
  left: 557px;
  width: 301px;
  height: 68px;
  border-radius: 5px;
  background-color: #d13560;
  color: #fff;
  align-self: center;
  font-size: 16px;
  font-weight: 500;

  &:focus,
  &:hover {
    background-color: #d1889d;
    color: #ffffff;
    box-shadow: 2px 2px 10px #00000029;
  }

  .icono-repo {
    margin-left: 6px;
    filter: invert(99%) sepia(99%) saturate(3%) hue-rotate(68deg)
      brightness(103%) contrast(100%);
  }
}

.tablero-multimedia {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-flow: row wrap;
  gap: 24px;


}


</style>
